module.exports = __webpack_public_path__ + "img/galeria-captores-7.c834c885.png";